import {object, string} from 'yup';
import {CURRENCIES_LIST} from '../../../../../../../constants/currencies';
import {PAYMENT_METHODS_LIST_WITH_NO_GATEWAY} from "../../../../../../../constants/paymentMethods";

const getID = (el) => el.id;

const obj = {};

PAYMENT_METHODS_LIST_WITH_NO_GATEWAY.forEach(({id, gatewaysList}) => {
  const availableNames = gatewaysList.map((el) => el.name).join(', ');
  obj[id] = string().oneOf(gatewaysList.map(getID), `This method can only have ${availableNames} payment gateway`);
});

obj['fiat_code'] = string().oneOf(CURRENCIES_LIST).required()

export default object(obj);
